import Box from '@elementor/ui/Box';
import Paper from '@elementor/ui/Paper';
import { styled } from '@elementor/ui/styles';
import AppTitle from '@components/header/title/app-title';
import { StyledHeaderContent } from '@styles/app.styles';

const ScannerTopBar = () => {
	return (
		<StyledHeaderContainer>
			<Paper color="secondary" elevation={0} square>
				<StyledHeaderContent>
					<StyledTitleWrapper>
						<Box display="flex" alignItems="center" gap={1}>
							<AppTitle />
						</Box>
					</StyledTitleWrapper>
				</StyledHeaderContent>
			</Paper>
		</StyledHeaderContainer>
	);
};

const StyledHeaderContainer = styled(Box)`
	position: sticky;
	top: 0;
	z-index: 3;

	overflow: visible;
`;

const StyledTitleWrapper = styled(Box)`
	display: flex;
	align-items: center;

	.MuiButtonBase-root {
		margin-inline-end: ${({ theme }) => theme.spacing(1)};
	}
`;

export default ScannerTopBar;
